/**
 * Cost-meter utilities. Prices in USD per 1M tokens, Anthropic Feb-2026.
 * The backend already computes cost per turn; these helpers just format it
 * and sum multi-turn sessions on the client for display.
 */
export const MODEL_PRICING = {
  'claude-opus-4-5-20251101':    { in:  15.0, out: 75.0, label: 'Opus 4.5'   },
  'claude-opus-4-1-20250805':    { in:  15.0, out: 75.0, label: 'Opus 4.1'   },  // legacy
  'claude-sonnet-4-5-20250929':  { in:   3.0, out: 15.0, label: 'Fable 5'    },
  'claude-haiku-4-5-20251001':   { in:   0.8, out:  4.0, label: 'Haiku 4.5'  },
  'claude-haiku-4-5-20250915':   { in:   0.8, out:  4.0, label: 'Haiku 4.5'  },  // legacy
};

/** Format a USD amount for chat display. `0.0032 → "$0.003"`, `0.42 → "$0.42"`. */
export function formatCostUsd(usd) {
  const n = Number(usd) || 0;
  if (n === 0) return '$0.00';
  if (n < 0.01) return `$${n.toFixed(4)}`;
  if (n < 1)    return `$${n.toFixed(3)}`;
  return `$${n.toFixed(2)}`;
}

/** Sum an array of per-turn usage dicts (from the /chat/status endpoint). */
export function computeCumulativeCost(turns) {
  return (turns || []).reduce(
    (acc, t) => {
      const u = t?.usage || {};
      acc.input_tokens += Number(u.input_tokens || 0);
      acc.output_tokens += Number(u.output_tokens || 0);
      acc.cache_read_input_tokens += Number(u.cache_read_input_tokens || 0);
      acc.cost_usd += Number(u.cost_usd || 0);
      return acc;
    },
    { input_tokens: 0, output_tokens: 0, cache_read_input_tokens: 0, cost_usd: 0 },
  );
}

/** Percentage of input tokens served from cache (higher = cheaper). */
export function cacheHitRate(usage) {
  const u = usage || {};
  const cached = Number(u.cache_read_input_tokens || 0);
  const total = Number(u.input_tokens || 0) + cached;
  if (total === 0) return 0;
  return Math.round((cached / total) * 100);
}
